import { AfterViewInit, ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { isNullOrUndefined } from '@sla-ng/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ICostCenterApportionment } from '../../../../../models/cost-center-apportionment.model';
import { IBabState } from '../../../../../services/facades/master-data/bab-state.model';
import { BabFacade } from '../../../../../services/facades/master-data/bab.facade';

@Component({
    templateUrl: './join-cost-center-cost-center-dialog.component.html',
    styleUrls: [ './join-cost-center-cost-center-dialog.component.scss' ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JoinCostCenterCostCenterDialogComponent implements OnInit, AfterViewInit {
    public babState$: Observable<IBabState>;
    public formGroup: FormGroup;
    public dialogFieldsValid: BehaviorSubject<boolean> = new BehaviorSubject(false);

    constructor(
        private myMatDialogRef: MatDialogRef<JoinCostCenterCostCenterDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ICostCenterApportionment,
        private myBabFacade: BabFacade,
    ) {}

    public ngOnInit(): void {
        if (isNullOrUndefined(this.data.id)) {
            this.preselectData();
        }
        this.babState$ = this.myBabFacade.subState();
    }

    public ngAfterViewInit(): void {
        this.formGroup.valueChanges.subscribe((apportionment: ICostCenterApportionment) => {
            this.validateDialogFields(apportionment);
        });
    }

    public async save(): Promise<void> {
        const data: ICostCenterApportionment = this.formGroup.value as ICostCenterApportionment;
        if (!isNullOrUndefined(this.data.id)) {
            await this.myBabFacade.updateApportionment(this.data.id, data.validTo, data.costTypeId);
        } else {
            await this.myBabFacade.addApportionment(data);
        }
        this.myMatDialogRef.close(true);
    }

    public close(): void {
        this.myMatDialogRef.close(false);
    }

    public validateDialogFields(apportionment: ICostCenterApportionment): void {
        if (isNullOrUndefined(this.data.id)
        && (isNullOrUndefined(apportionment.receivingCostCenterId)
            || isNullOrUndefined(apportionment.costAccountingTypeId)
            || isNullOrUndefined(apportionment.costTypeId)
            || isNullOrUndefined(apportionment.validFrom))) {
            this.dialogFieldsValid.next(false);
        } else if (!isNullOrUndefined(this.data.id)
            && (isNullOrUndefined(apportionment.costTypeId)
            || isNullOrUndefined(apportionment.validTo))) {
            this.dialogFieldsValid.next(false);
        } else {
            this.dialogFieldsValid.next(true);
        }
    }

    private preselectData(): void {
        const state: IBabState = this.myBabFacade.getStateSnapshot();
        this.data.costAccountingTypeId = state.selectedCostAccountingType;
        this.data.validFrom = state.selectedValidFrom;
    }
}
